import { reactive } from 'vue'
import {
	fetchNotificationList,
	updateNotification,
	updateNotificationEach,
} from '@/assets/ts/apiManagement'
import setWindowSettings from './setting'

setWindowSettings()

export enum NotificationType {
	all = '',
	order = 'NOTIFICATION_TYPE_CORE',
	account = 'NOTIFICATION_TYPE_ACCOUNT',
}

export enum NotificationTab {
	ALL = 'all',
	NOTIFICATION_TYPE_CORE = 'order',
	NOTIFICATION_TYPE_ACCOUNT = 'account',
}

interface INotificationItem {
	id: string
	title: string
	content: string
	type: NotificationType
	isRead: boolean
	createdTimestamp: number
	url: string
}

class NotificationList {
	_list: INotificationItem[]

	_tab: NotificationTab

	_type: NotificationType

	_isNotificationCenterEnabled: boolean

	constructor() {
		this._list = []
		this._tab = NotificationTab.ALL
		this._type = NotificationType.all
		this._isNotificationCenterEnabled =
			window.BUYANDSHIP.settings.notification_centre.enabled === 'yes'
	}

	get currentTab() {
		return this._tab
	}

	get currentType() {
		return this._type
	}

	get listAll() {
		if (this._list && this._list.length) {
			return this._list
		}
		return []
	}

	get listAllUnread() {
		if (this.listAll.length) {
			return this.listAll.filter(item => !item.isRead)
		}
		return []
	}

	get listCore() {
		if (this._list && this._list.length) {
			return this._list.filter(item => item.type === NotificationType.order)
		}
		return []
	}

	get listCoreUnread() {
		if (this.listCore.length) {
			return this.listCore.filter(item => !item.isRead)
		}
		return []
	}

	get listAccount() {
		if (this._list && this._list.length) {
			return this._list.filter(item => item.type === NotificationType.account)
		}
		return []
	}

	get listAccountUnread() {
		if (this.listAccount.length) {
			return this.listAccount.filter(item => !item.isRead)
		}
		return []
	}

	get listCurrent() {
		let list
		switch (this.currentTab) {
			case NotificationTab.NOTIFICATION_TYPE_CORE:
				list = this.listCore
				break
			case NotificationTab.NOTIFICATION_TYPE_ACCOUNT:
				list = this.listAccount
				break
			case NotificationTab.ALL:
				list = this.listAll
				break
			default:
				list = this.listAll
				break
		}
		return list
	}

	get isHasUnRead() {
		if (this._list && this._list.length) {
			return this._list.some(item => !item.isRead)
		}
		return false
	}

	get isNotificationEnabled() {
		return this._isNotificationCenterEnabled
	}

	setTab(tab: NotificationTab) {
		this._tab = tab
	}

	setType(type: NotificationType) {
		this._type = type
	}

	setList(payload: INotificationItem[]) {
		this._list = payload
	}

	async fetchList() {
		if (this.isNotificationEnabled) {
			const data = await fetchNotificationList()
			this.setList(data)
		}
	}

	async updateList(payload: any) {
		if (this._list && this._list.length) {
			if (payload.type === NotificationTab.ALL) {
				this._list.forEach(item => {
					item.isRead = true
				})
			} else {
				this._list.forEach(item => {
					if (item.type === payload.APItype) item.isRead = true
				})
			}
		}
		return updateNotification(payload)
	}

	async updateListEach(notificationId: string) {
		if (this._list && this._list.length) {
			const index = this._list.findIndex(item => item.id === notificationId)
			if (index >= 0) {
				this._list[index].isRead = true
			}
		}
		return updateNotificationEach(notificationId)
	}
}

const instanceNotification = reactive(new NotificationList())

export default instanceNotification
